import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './pages/ScrollToTop';

import HeroSection from './pages/HeroSection';
import CategorySection from './pages/CategorySection';
import WhyChooseUs from './pages/WhyChooseUs';
import WaterproofingCTA from './pages/WaterproofingCTA';
import BookConsultModal from './pages/BookConsultModal';


import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';

import TerraceWaterproofing from './pages/Services/TerraceWaterproofing';
import BathroomWaterproofing from './pages/Services/BathroomWaterproofing';
import BasementWaterproofing from './pages/Services/BasementWaterproofing';
import CrackRepair from './pages/Services/CrackRepair';
import RoofCoating from './pages/Services/RoofCoating';
import LeakDetectionConsultation from './pages/Services/LeakDetectionConsultation';
import TermsAndConditions from './pages/TermsAndConditions';
import TestimonialsSection from './pages/TestimonialsSection';
import MaterialsTechnology from './pages/MaterialsTechnology';
import HowWeWork from './pages/HowWeWork';
import WhatIsWaterproofing from './pages/WhatIsWaterproofing';


function App() {
  const [isConsultOpen, setIsConsultOpen] = useState(false);

  useEffect(() => {
    const alreadyShown = localStorage.getItem("consultPopupShown");
    if (!alreadyShown) setIsConsultOpen(true);
  }, []);

  const handleClose = () => {
    setIsConsultOpen(false);
    const alreadyShown = localStorage.getItem("consultPopupShown");
    if (!alreadyShown) {
      setTimeout(() => {
        setIsConsultOpen(true);
        localStorage.setItem("consultPopupShown", "true");
      }, 10000);
    }
  };

  return (
    <BrowserRouter>
      <Header setIsConsultOpen={setIsConsultOpen} />
      <ScrollToTop />

      {/* ✅ Single Routes block */}
      <Routes>
        <Route path="/" element={
          <>
            <HeroSection setIsConsultOpen={setIsConsultOpen} />
            
  <CategorySection />
            <MaterialsTechnology /> 
            <HowWeWork/>
            <WaterproofingCTA />
            <TestimonialsSection/>
            <WhatIsWaterproofing/>
            <WhyChooseUs />
          </>
        } />
       
      {/* <Route path="/projects" element={<Projects setIsConsultOpen={setIsConsultOpen} />} />*/}
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions/>} />
        <Route path="/terrace-waterproofing" element={<TerraceWaterproofing />} />
        <Route path="/bathroom-waterproofing" element={<BathroomWaterproofing />} />
        <Route path="/basement-waterproofing" element={<BasementWaterproofing />} />
        <Route path="/crack-repair" element={<CrackRepair />} />
        <Route path="/roof-coating" element={<RoofCoating />} />
        <Route path="/leak-detection-&-consultation" element={<LeakDetectionConsultation />} />
      </Routes>

      <Footer />
      <BookConsultModal isOpen={isConsultOpen} onClose={handleClose} />
    </BrowserRouter>
  );
}

export default App;
